module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.0-238.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.0.md
// module id = 682
// module chunks = 290